
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// getAllContactUsSectionsWithCreatorBySectionName
// getAllContactUsSectionsWithCreatorBySectionName


const GETALLCONTACTUSSECTIONSWITHCREATORBYSECTIONNAME= createAsyncThunk(
  "getAllContactUsSectionsWithCreatorBySectionName/getAllContactUsSectionsWithCreatorBySectionName",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllContactUsSectionsWithCreatorBySectionNameSlice = createSlice({
  name: "getAllContactUsSectionsWithCreatorBySectionNameSlice",
  initialState: {
    getAllContactUsSectionsWithCreatorBySectionName: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllContactUsSectionsWithCreatorBySectionName: (state) => {
        state.getAllContactUsSectionsWithCreatorBySectionName.loading = false
        state.getAllContactUsSectionsWithCreatorBySectionName.error = false
        state.getAllContactUsSectionsWithCreatorBySectionName.data = []
        state.getAllContactUsSectionsWithCreatorBySectionName.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCONTACTUSSECTIONSWITHCREATORBYSECTIONNAME.fulfilled, (state, action) => {
      state.getAllContactUsSectionsWithCreatorBySectionName = {
        ...state.getAllContactUsSectionsWithCreatorBySectionName,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCONTACTUSSECTIONSWITHCREATORBYSECTIONNAME.pending, (state, action) => {
      state.getAllContactUsSectionsWithCreatorBySectionName = {
        ...state.getAllContactUsSectionsWithCreatorBySectionName,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCONTACTUSSECTIONSWITHCREATORBYSECTIONNAME.rejected, (state, action) => {
      state.getAllContactUsSectionsWithCreatorBySectionName = {
        ...state.getAllContactUsSectionsWithCreatorBySectionName,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllContactUsSectionsWithCreatorBySectionNameAction = {
    GETALLCONTACTUSSECTIONSWITHCREATORBYSECTIONNAME,
};

export { getAllContactUsSectionsWithCreatorBySectionNameAction };
export default getAllContactUsSectionsWithCreatorBySectionNameSlice.reducer;
export const {setInitialStateOfgetAllContactUsSectionsWithCreatorBySectionName} = getAllContactUsSectionsWithCreatorBySectionNameSlice.actions
